import { useEffect, useRef, useState } from "react";
import { debounce } from "../@utils/debounce";
import { isBrowser } from "../isBrowser";

export const useWindowResize = () => {
  const [width, setWidth] = useState(isBrowser ? window.innerWidth : 0);
  const [height, setHeight] = useState(isBrowser ? window.innerHeight : 0);

  const { current: listener } = useRef(
    debounce(() => {
      if (!isBrowser) return;
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    }, 100),
  );

  useEffect(() => {
    if (!isBrowser) return;
    window.addEventListener("resize", listener);
    return () => {
      window.removeEventListener("resize", listener);
    };
    // eslint-disable-next-line react-hooks/refs
  }, [listener]);

  return {
    width,
    height,
  };
};
